<template>
	<h4>Priority Health Dental/Vision Plan(s) Terms &amp; Conditions</h4>
	<hr>
	<p>I confirm that I am enrolling myself and dependents selected above in the MyPriority Delta Dental – Standardor  MyPriority Delta Dental – Enhanced Plan and/or the MyPriority EyeMed – Medium or MyPriority EyeMed – High Plan.I understand the coverage I am selecting will not take effect until issued by Priority Health.</p>
</template>
